import { useEffect, useState } from "react";
import { Loader2, Sparkles } from "lucide-react";

/**
 * Visible loading state for AI generations that take 20-60 seconds.
 * Shows an elapsed-time counter and a reassuring message so users
 * don't think the app is frozen.
 */
export default function AILoadingState({ label = "Mister AI sta lavorando", expectedSeconds = 45 }) {
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const progress = Math.min(100, Math.round((secs / expectedSeconds) * 100));
  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 space-y-3" data-testid="ai-loading">
      <div className="relative">
        <Sparkles size={36} className="text-sky-400 animate-pulse" />
        <Loader2 size={48} className="absolute -inset-1.5 animate-spin text-sky-500" />
      </div>
      <p className="font-heading font-semibold text-slate-700">{label}</p>
      <p className="text-xs text-slate-500 text-center max-w-xs">
        Le generazioni AI di qualità richiedono <strong>30-60 secondi</strong>. Non chiudere la pagina.
      </p>
      <div className="w-full max-w-xs h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-sky-400 to-sky-600 transition-all duration-1000"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-xs font-mono text-slate-400">{secs}s</p>
    </div>
  );
}
